import React from "react";
import { Route, Switch } from "react-router-dom";
import { Crumb } from "@repoflow/components/breadcrumb";
import * as Section from "@repoflow/components/section";
import SitePackPublicSchema from "@common/schema/site-pack/public";

import * as ListRoute from "./list";
import * as NewRoute from "./new";
import * as PackRoute from "./pack";

// A site's route packs: prefixes served from an uploaded, unzipped bundle
// instead of by the renderer.
//
// A section of its own, beside Pages and Sections, because a pack is a route —
// it competes with pages for the same URL space — and not a property of one.
// The archived project put it in exactly this position, under the label "Route
// packs" (archive/recovered/stack-env/code/site-frontend/src/routes/domain/
// site/packs).
const LocalProvider = ({ match: { params }, children: Children }) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/pack`;
  const basepath = `${parentBasepath}/pack`;

  return (
    <Section.Provider
      schema={SitePackPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          {/* Before `/:packId`, which would otherwise match the literal. */}
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:packId`} component={PackRoute.Content} />
          <Route path={`${basepath}`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <Crumb to={`${base}`} label={"Route packs"} />
          <Switch>
            <Route path={`${basepath}/new`} component={NewRoute.Indice} />
            <Route path={`${basepath}/:packId`} component={PackRoute.Indice} />
            <Route path={`${basepath}`} component={ListRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => null;
